import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    root: {
    },
    countOrder: {
        marginRight: theme.spacing(1),
    },
    countStyle: {
        display: "inline-block !important", 
        marginRight: '5px' 
    },
    titleSize: { 
        marginTop: 20, 
        fontSize: '1.4rem' 
    },
    tableRowColor: { 
        background: '#212121' 
    },
}));

function ManualProcess() {
    const {t} = useTranslation('selfReturn');
    const classes = useStyles();

    const selfReturnManagement = useSelector(state => state.srReducer);

    const [rows, setRows] = useState([]);

    const columns = [
        t('driver_notes'), 
        t('extra_order_sn'), 
        t('is_taken'), 
        t('order_id'), 
        t('order_sn'), 
        t('pack_id'), 
        t('selfpick'), 
        t('shipping_staff_id'), 
        t('shipping_status')
    ]

    useEffect(() => {
        if(selfReturnManagement.driverAppReturnList.data) {
            setRows(selfReturnManagement.driverAppReturnList.data);
        }
    }, [selfReturnManagement.driverAppReturnList])
    
    return (
        <Box className={classes.root}>
            <div className={classes.titleSize}>{t('manual_process')}</div>
            <div style={{ marginTop: 10 }}>
                <Table>
                    <TableHead>
                        <TableRow className={classes.tableRowColor}>
                            {
                                columns.map((column) => (
                                <TableCell>{column}</TableCell>
                                ))
                            }                           
                        </TableRow>
                    </TableHead>
                    <TableBody>
                            {
                                rows.map((row) => (
                                    <TableRow>
                                        {
                                            columns.length > 0 && columns.map((column) => (
                                                <TableCell>{row[column]}</TableCell>
                                            ))
                                        }
                                    </TableRow>
                                ))
                            }
                    </TableBody>
                </Table>
            </div>           
        </Box>
    );   
}

export default ManualProcess;